export default __webpack_public_path__ + "static/media/img-0776-sweden-half-face.1a06f29f.png";